var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toaster',{on:{"close-toaster":_vm.closeSummaryToaster},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('span',[_vm._v("צפי ההוצאות על "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.categoryName))]),_vm._v(" ב"+_vm._s(_vm.timeFrameTitle)+" התעדכן")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }